import React from 'react';
import PropTypes from 'prop-types';

const ConnectIcon = ({ color }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.78633 10.8751C7.59329 10.8751 7.46459 10.8108 7.33589 10.6821C6.5637 9.90988 6.11326 8.88028 6.11326 7.78633C6.11326 6.69239 6.5637 5.66279 7.33589 4.89059L11.0038 1.22265C11.776 0.450449 12.8056 0 13.8995 0C14.9934 0 16.023 0.450449 16.7952 1.22265C18.4039 2.83139 18.4039 5.40539 16.7952 7.01414L15.1221 8.68723C14.8647 8.94463 14.4786 8.94463 14.2212 8.68723C13.9638 8.42983 13.9638 8.04373 14.2212 7.78633L15.8943 6.11324C16.9882 5.01929 16.9882 3.21749 15.8943 2.12355C15.3795 1.60875 14.6717 1.287 13.8995 1.287C13.1273 1.287 12.4195 1.60875 11.9047 2.12355L8.23678 5.79149C7.72198 6.30629 7.40024 7.01414 7.40024 7.78633C7.40024 8.55853 7.72198 9.26638 8.23678 9.78118C8.49417 10.0386 8.49417 10.4247 8.23678 10.6821C8.10808 10.8108 7.97938 10.8751 7.78633 10.8751Z"
      fill={color}
    />
    <path
      d="M4.11834 18.0178C3.08875 18.0178 1.99482 17.6317 1.22263 16.7952C0.450443 16.023 0 14.9934 0 13.8994C0 12.8055 0.450443 11.7759 1.22263 11.0037L2.89571 9.3306C3.1531 9.0732 3.5392 9.0732 3.79659 9.3306C4.05399 9.58799 4.05399 9.97409 3.79659 10.2315L2.12352 11.9046C1.60873 12.4194 1.28698 13.1272 1.28698 13.8994C1.28698 14.6716 1.60873 15.3795 2.12352 15.8943C3.21745 16.9882 5.01923 16.9882 6.11316 15.8943L9.78105 12.2263C10.2958 11.7115 10.6176 11.0037 10.6176 10.2315C10.6176 9.4593 10.2958 8.75145 9.78105 8.23665C9.52366 7.97925 9.52366 7.59315 9.78105 7.33575C10.0385 7.07835 10.4245 7.07835 10.6819 7.33575C11.4541 8.10795 11.9046 9.13755 11.9046 10.2315C11.9046 11.3254 11.4541 12.355 10.6819 13.1272L7.01404 16.7952C6.24186 17.5674 5.14792 18.0178 4.11834 18.0178Z"
      fill={color}
    />
  </svg>
);

ConnectIcon.propTypes = {
  color: PropTypes.string.isRequired,
};

export default ConnectIcon;
